// @flow
import FaqThemeList from 'components/contact/FaqThemeList';
import { connect } from 'react-redux';

import type { StateProps } from 'components/contact/FaqThemeList';
import type { StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      themes: state.faqState.themes,
      questions: state.faqState.questions,
    }),
  )(FaqThemeList)
);
